/*
 * HEROCO: Force manual variant selection on GemPages product pages. (v2)
 *
 * GemPages auto-selects the first variant on load and its "Default variant: No"
 * toggle does not suppress this for multi-option products. GemPages tracks the
 * selection with its OWN internal state: it checks the value's hidden radio
 * (.checked = true) AND removes the "unselected" styling classes from the chosen
 * box. It also re-applies that selection after a naive DOM reset, so we must
 * (a) tell GemPages the selection changed via a real `change` event, and
 * (b) keep undoing any re-selection until the shopper actually picks.
 *
 * On a GemPages PDP this script:
 *   1. clears the auto-selection of every multi-value option (uncheck radio +
 *      dispatch change so GemPages resets its own state/label/highlight, plus a
 *      class-level fallback so the box visually looks unselected),
 *   2. removes the ?variant= parameter from the URL (replaceState, no reload),
 *   3. hard-blocks Add to Cart (capturing click guard + visual lock) until every
 *      multi-value option has a chosen value.
 *
 * Self-gating: does nothing on pages without GemPages variant options. Single-
 * value options (e.g. a lone Color) are left selected. No product-specific IDs,
 * variant IDs or option names are hardcoded - everything is read at runtime.
 *
 * GemPages v7 markup:
 *   option group : div.variant-option-group[variant-option-name]
 *   option value : div.option-value-wrapper[option-value] + sibling input[type=radio]
 *   selected     : radio .checked === true; box LACKS the unselected styling classes
 *   add to cart  : button.gp-button-atc.add_to_cart
 */
(function () {
  'use strict';

  var HINT_TEXT = 'Please select an option';
  var MAX_DESELECTS = 40;   // runaway guard if GemPages keeps re-selecting
  var SETTLE_MS = 10000;    // keep undoing auto-selection this long (until user picks)

  var userInteracted = false;
  var observer = null;
  var busy = false;
  var deselects = 0;

  function groups() {
    return [].slice.call(document.querySelectorAll('.variant-option-group'));
  }
  function wrappers(g) {
    return [].slice.call(g.querySelectorAll('.option-value-wrapper'));
  }
  function radiosIn(g) {
    return [].slice.call(g.querySelectorAll('input[type="radio"]'));
  }
  function radioForValue(g, value) {
    var rs = radiosIn(g);
    for (var i = 0; i < rs.length; i++) { if (rs[i].value === value) return rs[i]; }
    return null;
  }
  function isMulti(g) {
    return wrappers(g).length > 1;
  }
  // per-value position class like "Size-2-1" - never copy these between boxes
  function isPositionClass(c) {
    return /^[A-Za-z0-9]+-\d+-\d+$/.test(c);
  }

  // Classes an unselected box has that the selected box lacks (excluding the
  // per-value position class). Re-adding them to the selected box makes it look
  // unselected - derived at runtime, so nothing is hardcoded.
  function unselectedDiff(g) {
    var sel = null, unsel = null;
    wrappers(g).forEach(function (w) {
      var r = radioForValue(g, w.getAttribute('option-value'));
      if (r && r.checked) sel = w; else if (!unsel) unsel = w;
    });
    if (!sel || !unsel) return null;
    var have = {};
    sel.className.split(/\s+/).forEach(function (c) { if (c) have[c] = 1; });
    var diff = unsel.className.split(/\s+/).filter(function (c) {
      return c && !have[c] && !isPositionClass(c);
    });
    return { box: sel, classes: diff };
  }

  function stripVariantParam() {
    try {
      if (location.search.indexOf('variant=') === -1) return;
      var u = new URL(location.href);
      u.searchParams.delete('variant');
      history.replaceState({}, document.title, u.pathname + u.search + u.hash);
    } catch (e) { /* noop */ }
  }

  function deselectAll() {
    if (userInteracted || deselects >= MAX_DESELECTS) return;
    busy = true;
    var changed = false;
    groups().forEach(function (g) {
      if (!isMulti(g)) return;
      var diff = unselectedDiff(g);
      radiosIn(g).forEach(function (r) {
        if (r.checked) {
          r.checked = false;
          // Tell GemPages the selection changed so it clears its own state,
          // the "Size: x" label and the highlight.
          r.dispatchEvent(new Event('input', { bubbles: true }));
          r.dispatchEvent(new Event('change', { bubbles: true }));
          changed = true;
        }
      });
      // Visual fallback: force the previously-selected box to look unselected.
      if (diff && diff.box && diff.classes.length) {
        diff.classes.forEach(function (c) { try { diff.box.classList.add(c); } catch (e) {} });
      }
    });
    if (changed) deselects++;
    stripVariantParam();
    applyAtc();
    setTimeout(function () { busy = false; }, 0);
  }

  // Complete when every option (by name, across desktop/mobile copies) is
  // single-value or has a checked radio.
  function selectionComplete() {
    var gs = groups();
    if (!gs.length) return true;
    var byName = {};
    gs.forEach(function (g) {
      var n = g.getAttribute('variant-option-name') || '';
      var e = byName[n] || (byName[n] = { multi: false, checked: false });
      if (isMulti(g)) e.multi = true;
      radiosIn(g).forEach(function (r) { if (r.checked) e.checked = true; });
    });
    return Object.keys(byName).every(function (n) {
      return !byName[n].multi || byName[n].checked;
    });
  }

  function atcButtons() {
    return [].slice.call(document.querySelectorAll('.gp-button-atc, button[name="add"].add_to_cart'));
  }
  function injectStyle() {
    if (document.getElementById('gp-atc-lock-style')) return;
    var s = document.createElement('style');
    s.id = 'gp-atc-lock-style';
    s.textContent = '.gp-atc-locked{opacity:.45 !important;}.gp-atc-hint{color:#b00020;font-size:14px;margin:8px 0 0;}';
    (document.head || document.documentElement).appendChild(s);
  }
  function showHint(btn) {
    var h = btn.parentNode;
    if (!h || h.querySelector('.gp-atc-hint')) return;
    var p = document.createElement('p');
    p.className = 'gp-atc-hint';
    p.textContent = HINT_TEXT;
    h.insertBefore(p, btn.nextSibling);
  }
  function removeHint(btn) {
    var h = btn.parentNode;
    if (!h) return;
    var p = h.querySelector('.gp-atc-hint');
    if (p && p.parentNode) p.parentNode.removeChild(p);
  }
  function applyAtc() {
    var complete = selectionComplete();
    atcButtons().forEach(function (btn) {
      if (complete) { btn.classList.remove('gp-atc-locked'); removeHint(btn); }
      else { btn.classList.add('gp-atc-locked'); showHint(btn); }
    });
  }

  function onUserInteract() {
    if (userInteracted) return;
    userInteracted = true;
    if (observer) { observer.disconnect(); observer = null; }
    setTimeout(applyAtc, 0);
  }

  // Document-level delegation - survives GemPages re-renders and InstantClick.
  function setupDelegationOnce() {
    if (window.__gpDelegationBound) return;
    window.__gpDelegationBound = true;

    document.addEventListener('pointerdown', function (e) {
      if (e.target.closest && e.target.closest('.variant-option-group')) onUserInteract();
    }, true);

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest && t.closest('.variant-option-group')) { onUserInteract(); setTimeout(applyAtc, 0); }
      var btn = t.closest && t.closest('.gp-button-atc, button[name="add"].add_to_cart');
      if (btn && !selectionComplete()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showHint(btn);
      }
    }, true);

    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('.variant-option-group')) setTimeout(applyAtc, 0);
    }, true);
  }

  function init() {
    var gs = groups();
    if (!gs.length) return false;
    if (document.body.__gpV2Init) { applyAtc(); return true; }
    document.body.__gpV2Init = true;

    injectStyle();
    setupDelegationOnce();

    deselectAll();
    applyAtc();

    // Undo any auto-selection GemPages applies/re-applies (class + DOM changes)
    // until the shopper makes a choice.
    if (observer) { observer.disconnect(); }
    observer = new MutationObserver(function () {
      if (busy || userInteracted) return;
      deselectAll();
    });
    gs.forEach(function (g) {
      observer.observe(g, { attributes: true, attributeFilter: ['class'], subtree: true, childList: true });
    });
    setTimeout(function () { if (observer) { observer.disconnect(); observer = null; } }, SETTLE_MS);

    return true;
  }

  function boot() {
    if (location.pathname.indexOf('/products/') === -1) return;
    userInteracted = false;
    deselects = 0;
    if (observer) { observer.disconnect(); observer = null; }
    document.body.__gpV2Init = false;

    if (init()) return;
    var tries = 0;
    var poll = setInterval(function () {
      tries++;
      if (init() || tries >= 80) clearInterval(poll); // up to ~8s for GemPages to render
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-run after InstantClick (pjax) navigations.
  var icTries = 0;
  var icPoll = setInterval(function () {
    icTries++;
    if (window.InstantClick && typeof window.InstantClick.on === 'function') {
      window.InstantClick.on('change', boot);
      clearInterval(icPoll);
    } else if (icTries >= 50) {
      clearInterval(icPoll);
    }
  }, 100);
})();
